import React from "react";
import "./MenuTable.css"
import table from "../../images/restorent_menu.png"

const MenuTable = () => {
  return (
    <section className="troo_da_most_populer_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="most_popular_dishes_title text-center">
              <div className="hero_small_detail we_service_small_title m-auto">
                <p>Most popular dishes</p>
              </div>
              <div className="service_title">
                <h2>See our restaurant menu</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="menu_outer">
              <div className="menu_title">
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Albacore tuna</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$05</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Crispy chicken melt</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$15</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Downtown wrap</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$10</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Mindfreak burger</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$06</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Fire roasted tortilla</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$05</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Spicy buffalo chichen</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$08</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="menu_dishes_img">
              <img
                src={table}
                alt="restorent_menu"
              />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="menu_outer">
              <div className="menu_title">
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Gene kelly’s beef stew</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$09</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>The mixwd grill</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$05</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Kansas chicken</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$06</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>New york strip</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$03</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Donut burger</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$12</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
                <div className="menu_box">
                  <div className="menu_dish_name_outer d-flex justify-content-between">
                    <div className="menu_dish_name">
                      <h5>Cubano Tuna</h5>
                    </div>
                    <div className="menu_dish_price">
                      <h5>$10</h5>
                    </div>
                  </div>
                  <div className="menu_content">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor
                      sit ame.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="show_full_menu_btn text-center">
          <button type="button" className="btn btn-primary">
            View Full Menu
          </button>
        </div>
      </div>
    </section>
  );
};

export default MenuTable;
